import { createContext, useContext, RefObject } from 'react';

interface DialogBoundaryContextType {
  boundaryRef: RefObject<HTMLElement> | null;
}

export const DialogBoundaryContext = createContext<DialogBoundaryContextType>({
  boundaryRef: null,
});

export const useDialogBoundary = () => {
  const context = useContext(DialogBoundaryContext);
  return context.boundaryRef?.current || null;
};

export const DialogBoundaryProvider = DialogBoundaryContext.Provider;
